import { env } from '@/lib/env';

export type AppRuntimeTarget = 'desktop' | 'web';

export function getRuntimeTarget(): AppRuntimeTarget {
  if (env.VITE_RUNTIME_TARGET === 'desktop' || env.VITE_RUNTIME_TARGET === 'web') {
    return env.VITE_RUNTIME_TARGET;
  }

  if (typeof window !== 'undefined' && window.desktop) {
    return 'desktop';
  }

  return 'web';
}

export function isDesktopRuntime() {
  return getRuntimeTarget() === 'desktop';
}

export function getAppPublicUrl() {
  if (env.VITE_APP_PUBLIC_URL.trim()) {
    return env.VITE_APP_PUBLIC_URL.trim();
  }

  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  return '';
}

export function getCopilotRuntimeInfo(): AppAiRuntimeInfo {
  const runtimeUrl = env.VITE_COPILOT_RUNTIME_URL.trim() || null;
  const model = env.VITE_COPILOT_MODEL.trim() || null;

  if (!runtimeUrl) {
    return {
      enabled: false,
      runtimeUrl: null,
      model,
      reason: 'Missing VITE_COPILOT_RUNTIME_URL.',
    };
  }

  return {
    enabled: true,
    runtimeUrl,
    model,
  };
}
